// extracted by mini-css-extract-plugin
module.exports = {"icon":"AssetIcon_icon__3mdsF"};